<div
  class="week-picker-list"
  [ngClass]="{ 'with-years': showYears, 'without-years': !showYears }"
>
  <div
    class="week-selector"
    [ngClass]="{ 'with-years': showYears, 'without-years': !showYears }"
    #weekSelector
  >
    @for (w of weeks; track w) {
      <div
        class="ag-list-item"
        [ngClass]="{ 'is-selected': week === w }"
        (click)="setWeek($event, w)"
      >
        {{ w }}
      </div>
    }
  </div>
  <div
    class="year-selector"
    [ngClass]="showYears ? null : 'hide-element'"
    #yearSelector
  >
    @for (y of years; track y) {
      <div
        class="ag-list-item"
        [ngClass]="{ 'is-selected': year === y }"
        (click)="setYear($event, y)"
      >
        {{ y }}
      </div>
    }
  </div>
  <button type="button" class="button is-info" id="week-picker-done-button">
    Done
  </button>
</div>
